const reISO = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)Z$/;
const reMsAjax = /^\/Date\((d|-|.*)\)[/|\\]$/;

export const parseWithDate = function (json) {
    /// <summary>
    /// parses a JSON string and turns ISO or MSAJAX date strings
    /// into native JS date objects
    /// </summary>
    /// <param name="json" type="var">json with dates to parse</param>
    /// </param>
    /// <returns type="value, array or object" />
    try {
        return JSON.parse(json, function (key, value) {
            if (typeof value === 'string') {
                let a = reISO.exec(value);
                if (a) {
                    const seconds = Math.floor(+a[6]);
                    const milliseconds = Math.round((+a[6] - seconds) * 1000);
                    return new Date(Date.UTC(+a[1], +a[2] - 1, +a[3], +a[4], +a[5], seconds, milliseconds));
                }
                a = reMsAjax.exec(value);
                if (a) {
                    const b = a[1].split(/[-+,.]/);
                    return new Date(b[0] ? +b[0] : 0 - +b[1]);
                }
            }

            if (value && typeof value === 'object' && Object.prototype.toString.apply(value) !== '[object Array]') {
                const replacement = {};
                for (const k in value) {
                    if (Object.hasOwnProperty.call(value, k)) {
                        replacement[k && k.charAt(0).toLowerCase() + k.substring(1)] = value[k];
                    }
                }
                return replacement;
            }
            return value;
        });
    } catch {
        // original error thrown has no error message so rethrow with message
        return json;
    }
};

export default {parseWithDate};
